import React from 'react'
import { Input, Button, Table, Tabs } from "antd";
import StyledPeoplePage from "../../../Pages/Settings/People/style";
import { SearchOutlined, RightOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
// Styled Component Container for all sections
const Customstyle = styled.div`
 text-align:left;
 .total-course{
 display:flex;
 align-items:center;
 justify-content:space-between;
 }
 .task{
 font-size:16px;
 font-weight:400;
 }
 .cardstyle{
  flex: 1;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
     background-color:#F4F4F4;
 }
 .totalcard{
    display: flex;
    justify-content: space-between;
    gap: 10px;
 }
    .title{
    font-size:28px;
    font-weight:700;
    }
    .dec{
    font-size:16px;
    font-weight:400;
    }
    .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: black !important; 
}
.ant-tabs-ink-bar {
  background-color: black !important; 
  }
.ant-tabs-tab {
  color: #636980 !important;
  font-weight: 500;
  font-size: 16px;
}
.ant-tabs-tab:hover {
  color: black !important;
}
  `;
function GroupDesign() {
    const navigate = useNavigate();
    const cardData = [
      { id: 1, title: "200", description: "People" },
      { id: 2, title: "20", description: "Assigned Course" },
      { id: 3, title: "25%", description: "Completion Rate" },
      { id: 4, title: "2 hrs", description: "Average time taken" },
    ];
    const onChange = (key) => {
      console.log(key);
    };
    const columns = [
        {
          title: "Employee ID",
          dataIndex: "employeeid",
          key: "employeeid",
        },
        {
          title: "Employee Name",
          dataIndex: "employeename",
          key: "employeename",
        },
        {
          title: "Role",
          dataIndex: "role",
          key: "role",
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
          },
          {
            title: "Enrolled in",
            dataIndex: "enrolledin",
            key: "enrolledin",
          },
          {
            title: "Completed",
            dataIndex: "completed",
            key: "completed",
          },
          {
            title: "In Progress",
            dataIndex: "inprogress",
            key: "inprogress",
          },
          {
            title: "Not Started",
            dataIndex: "notstarted",
            key: "notstarted",
          },
          {
            title: "Country",
            dataIndex: "country",
            key: "country",
          },
          {
            title: "Grade Code",
            dataIndex: "gradecode",
            key: "gradecode",
          },
          {
            title: "Grade",
            dataIndex: "grade",
            key: "grade",
          },
          {
            title: "Competency",
            dataIndex: "competency",
            key: "competency",
          },
          {
            title: "Service Line",
            dataIndex: "serviceline",
            key: "serviceline",
          },
          {
            title: "Department",
            dataIndex: "notstarted",
            key: "notstarted",
          },
      ];
      const data = [
        {
          key: "1",
            employeeid: "WA12345",
            employeename: "Henry Becquerel",
            role: "Developer",
            type:"Learner-Type",
            enrolledin:"15",
            completed:"15",
            inprogress:"5",
            notpassed:"0",
            notstarted: "0",
            country: "Kenya",
            gradecode: "C2",
            grade: "Senior 2",
            competency: "Audit",
            serviceline: "Audit",
            department: "Audit",
        },
        {
          key: "2",
          employeeid: "WA12345",
          employeename: "Henry Becquerel",
          role: "Developer",
          type:"Learner-Type",
          enrolledin:"15",
          completed:"15",
          inprogress:"5",
          notpassed:"0",
          notstarted: "0",
          country: "Kenya",
        gradecode: "C2",
        grade: "Senior 2",
        competency: "Audit",
        serviceline: "Audit",
        department: "Audit",
        },
        {
            key: "3",
            employeeid: "WA12345",
            employeename: "Henry Becquerel",
            role: "Developer",
            type:"Learner-Type",
            enrolledin:"15",
            completed:"15",
            inprogress:"5",
            notpassed:"0",
            notstarted: "0",
            country: "Kenya",
            gradecode: "C2",
            grade: "Senior 2",
            competency: "Audit",
            serviceline: "Audit",
            department: "Audit",
            },
          {
            key: "4",
            employeeid: "WA12345",
            employeename: "Henry Becquerel",
            role: "Developer",
            type:"Learner-Type",
            enrolledin:"15",
            completed:"15",
            inprogress:"5",
            notpassed:"0",
            notstarted: "0",
            country: "Kenya",
            gradecode: "C2",
            grade: "Senior 2",
            competency: "Audit",
            serviceline: "Audit",
            department: "Audit",    
          },
      ];

      const columns1 = [
        {
          title: "Code",
          dataIndex: "code",
          key: "code",
        },
        {
          title: "Course Name",
          dataIndex: "coursename",
          key: "coursename",
        },
        {
          title: "People Enrolled",
          dataIndex: "peopleenrolled",
          key: "peopleenrolled",
        },
        {
            title: "Completed",
            dataIndex: "completed",
            key: "completed",
          },
          {
            title: "In Progress",
            dataIndex: "inprogress",
            key: "inprogress",
          },
          {
            title: "Not Passed",
            dataIndex: "notpassed",
            key: "notpasses",
          },
          {
            title: "Not Started",
            dataIndex: "notstarted",
            key: "notstarted",
          },
      ];
      const data1= [
        {
         code: "234",
         coursename: "General Tips to crack Interview",
         peopleenrolled: "200",
         completed: "150",
         inprogress: "40",
         notpassed: "6",
         notstarted: "4",
 
        },
        {
            code: "234",
            coursename: "General Tips to crack Interview",
            peopleenrolled: "200",
            completed: "150",
            inprogress: "40",
            notpassed: "6",
            notstarted: "4",
    
           },
           {
            code: "234",
            coursename: "General Tips to crack Interview",
            peopleenrolled: "200",
            completed: "150",
            inprogress: "40",
            notpassed: "6",
            notstarted: "4",
    
           },
           {
            code: "234",
            coursename: "General Tips to crack Interview",
            peopleenrolled: "200",
            completed: "150",
            inprogress: "40",
            notpassed: "6",
            notstarted: "4",
           },
      ];

      const columns2 = [
        {
          title: "Activity Type",
          dataIndex: "activitytype",
          key: "activitytype",
        },
        {
          title: "Date & Time",
          dataIndex: "dateandtime",
          key: "dateandtime",
        },
        {
          title: "Detail",
          dataIndex: "detail",
          key: "detail",
        },
      ];

      const data2= [
        {
         activitytype: "User Added",
         dateandtime: "20th Aug 2024; 08:10 PM",
         detail: "Rohan was added into the group by You",
        },
        {
            activitytype: "Course Edited",
            dateandtime: "20th Aug 2024; 08:10 PM",
            detail: "Basics of Management was edited by Neeraj Shah",
           },
           {
            activitytype: "User Added",
            dateandtime: "20th Aug 2024; 08:10 PM",
            detail: "Rohan was added into the group by You",
           },
           {
            activitytype: "Course Edited",
            dateandtime: "20th Aug 2024; 08:10 PM",
            detail: "Basics of Management was edited by Neeraj Shah",
           },
      ];

      const items = [
        {
          key: "1",
          label: "People",
          children: (
            <>
              <Input
                placeholder="Search in People"
                prefix={<SearchOutlined style={{ color: "#636980" }} />}
                className="searchbar-style"
                style={{ marginBottom: "16px" }}
              />
              <Table
                columns={columns}
                dataSource={data}
                scroll={{ x: "30%" }}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-white" : "table-row-gray"
                }
                className="custom-table"
                pagination={false}
                // onRow={(record) => ({
                //   onClick: () => {
                //     navigate("/reportgroup");
                //   },
                // })}
              />
            </>
          ),
        },
        {
          key: "2",
          label: "Course",
          children: (
            <>
              <Input
                placeholder="Search in Course"
                prefix={<SearchOutlined style={{ color: "#636980" }} />}
                className="searchbar-style"
                style={{ marginBottom: "16px" }}
              />
              <Table
                columns={columns1}
                dataSource={data1}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-white" : "table-row-gray"
                }
                className="custom-table"
                pagination={false}
              />
            </>
          ),
        },
        {
          key: "3",
          label: "Activity Log",
          children: (
            <>
              <Input
                placeholder="Search in Activity Log"
                prefix={<SearchOutlined style={{ color: "#636980" }} />}
                className="searchbar-style"
                style={{ marginBottom: "16px" }}
              />
              <Table
                columns={columns2}
                dataSource={data2}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-white" : "table-row-gray"
                }
                className="custom-table"
                pagination={false}
              />
            </>
          ),
        },
      ];
  return (
    <div>
        <StyledPeoplePage>
            <Customstyle>
            <div className="flex text-left gap-3">
            <p
              className="custom-field"
              onClick={() => {
                navigate("/course-report");
              }}
            >
              Group Report
            </p>
            <RightOutlined className="w-[14px] h-[24px]" />
            <p className="editing-creating-text">Design</p>
          </div>
          <br/>
          <div className='totalcard'>
          {cardData.map((card) => (
        <div key={card.id} className='cardstyle'>
          <p className='title'>{card.title}</p>
          <p className='desc'>{card.description}</p>
        </div>
      ))}
      </div>
      <Tabs tabBarStyle={{width: "250px"}} defaultActiveKey="1" items={items} onChange={onChange} />
          </Customstyle>
          </StyledPeoplePage>
    </div>
  )
}
export default GroupDesign